import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';

const MemberDetailModal = ({ member, open, onClose }) => {
  if (!member) return null;

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-2xl font-serif text-black">
            Member Details
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-6">
          {/* Personal Information */}
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="text-lg font-semibold text-black mb-4">Personal Information</h3>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <p className="text-sm text-gray-600">First Name</p>
                <p className="font-medium text-black">{member.first_name}</p>
              </div>
              <div>
                <p className="text-sm text-gray-600">Last Name</p>
                <p className="font-medium text-black">{member.last_name}</p>
              </div>
              <div>
                <p className="text-sm text-gray-600">Email</p>
                <p className="font-medium text-black">{member.email}</p>
              </div>
              <div>
                <p className="text-sm text-gray-600">Phone</p>
                <p className="font-medium text-black">{member.phone}</p>
              </div>
            </div>
          </div>

          {/* Agreement Information */}
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="text-lg font-semibold text-black mb-4">Agreement Information</h3>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <p className="text-sm text-gray-600">Signed At</p>
                <p className="font-medium text-black">{formatDate(member.accepted_at)}</p>
              </div>
              <div>
                <p className="text-sm text-gray-600">Agreement Version</p>
                <p className="font-medium text-black">{member.agreement_version}</p>
              </div>
              <div>
                <p className="text-sm text-gray-600">Record ID</p>
                <p className="font-mono text-xs text-black">{member.id}</p>
              </div>
              <div>
                <p className="text-sm text-gray-600">IP Address</p>
                <p className="font-medium text-black">{member.ip_address || 'N/A'}</p>
              </div>
            </div>
          </div>

          {/* Email Status */}
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="text-lg font-semibold text-black mb-4">Email Status</h3>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <p className="text-sm text-gray-600">Confirmation Email</p>
                <p className={`font-medium ${member.confirmation_email_sent ? 'text-green-600' : 'text-red-600'}`}>
                  {member.confirmation_email_sent ? '✓ Sent' : '✗ Not Sent'}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-600">Internal Notification</p>
                <p className={`font-medium ${member.internal_notification_sent ? 'text-green-600' : 'text-red-600'}`}>
                  {member.internal_notification_sent ? '✓ Sent' : '✗ Not Sent'}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-600">Webhook</p>
                <p className={`font-medium ${member.webhook_sent ? 'text-green-600' : 'text-red-600'}`}>
                  {member.webhook_sent ? '✓ Sent' : '✗ Not Sent'}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-600">MailerLite CRM</p>
                <p className={`font-medium ${member.mailerlite_added ? 'text-green-600' : 'text-red-600'}`}>
                  {member.mailerlite_added ? '✓ Added' : '✗ Not Added'}
                </p>
              </div>
            </div>
          </div>

          {/* Agreement Text */}
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="text-lg font-semibold text-black mb-4">Agreement Text Signed</h3>
            <div className="max-h-64 overflow-y-auto bg-white p-4 rounded border border-gray-200">
              <pre className="text-xs whitespace-pre-wrap font-serif text-gray-700">
                {member.agreement_text}
              </pre>
            </div>
          </div>

          <div className="flex justify-end">
            <Button onClick={onClose} variant="outline">
              Close
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MemberDetailModal;
